
import RecommendFoodLine from "./RecommendFoodLine.vue";
import { 
  FoodRecommendationListData,
  FoodRecommendationListLine,
  FoodRecommendationListItem
} from "@/types/home";
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  components: {
    RecommendFoodLine
  },
  name: "RecommendFoodView",
  props: {
    data: {
      type: FoodRecommendationListData,
      default: null,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const getMessageTitle = () => {
      return props.data && props.data.response && props.data.response.reason ? props.data.response.reason.title : "";  
    };
    const getMessage = () => {
      return props.data && props.data.response && props.data.response.reason ? props.data.response.reason.description : "";
    };
    const isShowMessage = () => {
      return getMessageTitle() || getMessage();
    };
    const getList = () =>{
      const lineList = Array<FoodRecommendationListLine>();
      if (props.data && props.data.response && props.data.response.foods) {
        let i = 0;
        let list = Array<FoodRecommendationListItem>();
        props.data.response.foods.forEach(item => {
          if (i == 2) {
            lineList.push(new FoodRecommendationListLine(list));
            list = Array<FoodRecommendationListItem>();
            i = 0;
          }
          list.push(item);
          i++;
        });
        for (let j = i; j < 2; j++) {
          const item = new FoodRecommendationListItem();
          list.push(item);
        }
        if (list.length != 0) {
          lineList.push(new FoodRecommendationListLine(list));
        }
      }
      NativeClient.sendDebugLog(
        "RecommendFoodView getList lineList=" + JSON.stringify(lineList)
      );
      return lineList;
    };
    const selectFood = (id: string, type: string, foodId: string) => {
      NativeClient.sendDebugLog(
        "RecommendFoodView selectFood id=" + id + " type=" + type + " foodId=" + foodId
      );
      context.emit("select-food", id, type, foodId);
    };
    return {
      isShowMessage,
      getMessageTitle,
      getMessage,
      getList,
      selectFood
    };
  }
});
